(function() {

	// formats menu tabs
	$( '.formats-body-menu-tab-blue' ).on( 'click', function( event ){

		event.preventDefault();
		var tabTriggers = document.getElementsByClassName( 'formats-body-menu-tab-blue' );
		var tabs = document.getElementsByClassName( 'formats-body-content' );

		for( b = 0; b < tabTriggers.length; b++ ) {

			if( tabTriggers[ b ] === event.target ) {

				tabTriggers[ b ].classList.remove( 'badge-default-blue' );
				tabTriggers[ b ].classList.add( 'badge-primary-blue' );

			} else {

				tabTriggers[ b ].classList.remove( 'badge-primary-blue' );
				tabTriggers[ b ].classList.add( 'badge-default-blue' );

			}
		}

		for ( i = 0; i < tabs.length; i++ ) {
			tabs[i].className = tabs[i].className.replace( ' active', '' );
		}

		var href = $( this ).attr( 'href' );

		$( href ).toggleClass( 'active' );

		return false;

	});

	$( '.formats-body-menu-tab-green' ).on( 'click', function( event ){

		event.preventDefault();
		var tabTriggers = document.getElementsByClassName( 'formats-body-menu-tab-green' );
		var tabs = document.getElementsByClassName( 'formats-body-content' );

		for( b = 0; b < tabTriggers.length; b++ ) {

			if( tabTriggers[ b ] === event.target ) {

				tabTriggers[ b ].classList.remove( 'badge-default-green' );
				tabTriggers[ b ].classList.add( 'badge-primary-green' );

			} else {

				tabTriggers[ b ].classList.remove( 'badge-primary-green' );
				tabTriggers[ b ].classList.add( 'badge-default-green' );

			}
		}

		for ( i = 0; i < tabs.length; i++ ) {
			tabs[i].className = tabs[i].className.replace( ' active', '' );
		}

		var href = $( this ).attr( 'href' );

		$( href ).toggleClass( 'active' );

		return false;

	});

	// formats hero menu tabs
	$( '.format-hero-body-menu-tab' ).on( 'click', function( event ){

		event.preventDefault();
		var tabTriggers = document.getElementsByClassName( 'format-hero-body-menu-tab' );
		var tabs = document.getElementsByClassName( 'format-hero-body-content' );

		for( b = 0; b < tabTriggers.length; b++ ) {

			if( tabTriggers[ b ] === event.target ) {

				tabTriggers[ b ].classList.remove( 'badge-default' );
				tabTriggers[ b ].classList.add( 'badge-primary' );

			} else {

				tabTriggers[ b ].classList.remove( 'badge-primary' );
				tabTriggers[ b ].classList.add( 'badge-default' );

			}
		}

		for (i = 0; i < tabs.length; i++) {
			tabs[i].className = tabs[i].className.replace( ' active', '' );
		}

		var href = $( this ).attr( 'href' );

		$( href ).toggleClass( 'active' );

		return false;

	});

})();
